import React, { useState } from "react";

import {
  RadioGroup,
  Stack,
  Typography,
  FormControlLabel,
  Radio,
} from "@mui/material";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

const RadioOption = ({
  value,
  label,
  checked,
}: {
  value: string;
  label: string;
  checked: string;
}) => {
  return (
    <FormControlLabel
      value={value}
      control={<Radio checked={checked === value} sx={{ py: 0.5 }} />}
      label={
        <Typography
          variant="bodySecondaryReg"
          sx={{ color: "shades.neutral.600" }}
        >
          {label}
        </Typography>
      }
    />
  );
};

type ConfirmType = "onlyThisMeeting" | "allMeetingsInSeries";

export interface EditRecurringMeetingModalProps
  extends Omit<ConfirmationModalProps, "children" | "title" | "onConfirm"> {
  onConfirm: (selected: ConfirmType) => void;
}

const EditRecurringMeetingModal = ({
  onConfirm,
  ...props
}: EditRecurringMeetingModalProps) => {
  const [selected, setSelected] = useState("onlyThisMeeting");

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(e.target.value);
  };

  return (
    <ConfirmationModal
      {...props}
      onConfirm={() => onConfirm(selected as ConfirmType)}
      title="Edit recurring meeting?"
      confirmProps={{ label: "Apply" }}
    >
      <Stack>
        <Typography variant="bodyPrimaryReg">
          Which meeting would you like to make changes to?
        </Typography>
        <RadioGroup onChange={handleSelect}>
          <Stack sx={{ mt: 1 }}>
            <RadioOption
              value="onlyThisMeeting"
              label="This meeting only"
              checked={selected}
            />
            <RadioOption
              value="allMeetingsInSeries"
              label="This and all future meetings in this series"
              checked={selected}
            />
          </Stack>
        </RadioGroup>
      </Stack>
    </ConfirmationModal>
  );
};

export default EditRecurringMeetingModal;
